// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__KP6qx","footer":"Form_footer__3U4iV"};